export const roleMenu = 'menu';
export const roleMenuItem = 'menuitem';
